import { render, staticRenderFns } from "./CoachList.vue?vue&type=template&id=4a5a3c2c&scoped=true&"
import script from "./CoachList.vue?vue&type=script&lang=js&"
export * from "./CoachList.vue?vue&type=script&lang=js&"
import style0 from "./CoachList.vue?vue&type=style&index=0&id=4a5a3c2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a3c2c",
  null
  
)

export default component.exports